import { computed } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { queryKeys } from '../queryKeys';

import { accountProperties } from '@/api/routes/properties';
import apiClient from '@/modules/ApiClient';
import { useAccountsService } from '@/modules/Accounts/services/AccountsService';
import type { Property } from '@/modules/Properties/types';

export function useAccountPropertiesQuery() {
  const accountsService = useAccountsService();
  const accountId = computed(() => accountsService.account?.id ?? '');

  return useQuery({
    queryKey: computed(() => queryKeys.properties.account(accountId.value)),
    queryFn: async () => {
      const { data } = await apiClient.request<{ data: Property[] }>({
        method: 'GET',
        url: accountProperties,
        pathParams: { account: accountId.value },
        params: { per_page: 1000, page_num: 1 },
      });

      return data.data ?? [];
    },
    enabled: computed(() => Boolean(accountId.value)),
    ...ENTITY_LIST_QUERY_OPTIONS,
  });
}
